import { toggleTheme } from './mutations'

const resolvers = {
  Mutation: {
    toggleTheme,
  },
}

export default resolvers
